<h2 mat-dialog-title>Search Operations</h2>
<mat-dialog-content>
  <app-operation-search (addOperation)="onAddOperation($event)"></app-operation-search>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>